import React from "react";
import SectionTitle from "../SectionTitle/SectionTitle";
import "./VisualProof.css";

const proofs = [
  {
    title: "Close do produto",
    image: "sequencia/1.png",
  },
  {
    title: "Sobremesa montada",
    image: "sequencia/2.png",
  },
  {
    title: "Aplicação no restaurante",
    image: "sequencia/3.png",
  },
  {
    title: "Consumo real",
    image: "sequencia/4.png",
  },
];

function VisualProof() {
  return (
    <section className="visual-proof section">
      <div className="container">
        <SectionTitle
          center
          eyebrow="Prova visual"
          title="Produto que gera desejo antes mesmo da primeira venda"
          description="A ideia é usar fotos e vídeos curtos para mostrar textura, cremosidade, aplicação e consumo real."
        />

        <div className="visual-proof__scroll">
          {proofs.map((item) => (
            <div className="visual-proof__card" key={item.title}>
              <img src={item.image} alt={item.title} />
              <div>
                <strong>{item.title}</strong>
                <span>Ideal para Reels, anúncios e WhatsApp comercial</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default VisualProof;